import React from 'react';
import ChartBlock from '../ChartBlock';
import { useStatsPrint } from '../printContext';
import DistrictMap from './DistrictMap';

/** Bloco "Mapa de calor dos bairros" da seção Pacientes; fica fora do PDF (o ranking de bairros resume). */
const DistrictMapBlock = ({ map, period }) => {
  const print = useStatsPrint();
  if (print || !map || !period) return null;
  return (
    <ChartBlock title="Mapa de calor dos bairros" hint="onde moram os pacientes atendidos">
      <DistrictMap initial={map} period={period} />
    </ChartBlock>
  );
};

export default DistrictMapBlock;
